import { useState } from "react";
import { User, emptyUser } from "../types/entities";

//This custom hook has the information needed of the user
export function useLogin() {
	const [isLogged, setIsLogged] = useState(false);

	const [isLoggedWithGoogle, setIsLoggedWithGoogle] = useState(false);

	const [isCalledFromProfile, setIsCalledFromProfile] = useState(false);

	const onLogin = () => {
		setIsLogged(true);
		setIsLoggedWithGoogle(false);
	};

	const onLoginWithGoogle = () => {
		setIsLogged(true);
		setIsLoggedWithGoogle(true);
	};

	const onLogout = (onChangeUser: (customer: User) => void) => {
		setIsLogged(false);
		setIsLoggedWithGoogle(false);
		onChangeUser(emptyUser);
	};

	return {
		isLogged,
		isLoggedWithGoogle,
		isCalledFromProfile,
		onLogin,
		onLogout,
		onLoginWithGoogle,
		setIsCalledFromProfile,
	};
}
